import {AfterViewInit, Component, EventEmitter, HostBinding, Input, Output} from '@angular/core';
import {Word} from "../../models/word.model";
import {
  // 나중에 품사 표시를 복구할 수 있으므로 삭제하지 말 것 (#371).
  // GetPoomsaTxt,
  hunBody,
  hunChar,
} from '../../defines/gukeo.func';
import {WORD_LIST_MEANING} from '../../defines/client.const';

@Component({
  selector: 'app-link-popup-item-word',
  templateUrl: './link-popup-item-word.component.html',
})
export class LinkPopupItemWordComponent implements AfterViewInit {
  @HostBinding('style.display') styleBlock = 'block';
  @HostBinding('class') class = 'tooltip-item';
  @Input() word?: Word;
  @Input() showMoreBtn = true; // 더보기 버튼 표시 여부
  @Input() dispTxt?: string;
  @Output() close = new EventEmitter<string | null>();
  @Output() afterViewInit = new EventEmitter<void>();

  // 나중에 품사 표시를 복구할 수 있으므로 삭제하지 말 것 (#371).
  // protected readonly GetPoomsaTxt = GetPoomsaTxt;
  protected readonly hunBody = hunBody;
  protected readonly hunChar = hunChar;

  ngAfterViewInit() {
    this.afterViewInit.emit();
  }

  protected onGotoDetail($event: MouseEvent): void {
    $event.stopPropagation();
    $event.preventDefault();
    this.close.emit(this.word?.id);
  }

  protected onClose($event: MouseEvent): void {
    $event.stopPropagation();
    $event.preventDefault();
    this.close.emit(null);
  }

  /**
   * 링크 표시어와 동일한 관련어가 있다면 반환한다.
   * @param word
   * @protected
   */
  // protected getDerivative(word: SimpleWord): string | null {
  //   const derivative = word.derivative?.find(d => d === this.dispTxt);
  //   return derivative ?? null;
  // }


  protected getMoreMeanings(word: Word): number {
    // const more = Math.max(0, (word?.meaning?.length ?? 0) - WORD_LIST_MEANING - 1)
    // console.warn('getMoreMeanings() ', more);
    return Math.max(0, (word?.meaning?.length ?? 0) - WORD_LIST_MEANING - 1); // -1 = 기본 뜻의 갯수는 뺀다.
  }

}
